export default __webpack_public_path__ + "media/images/brighteon-social/tutorial/Brighteon-Social-Post-Reply-Box-f487f246cf7f44d32844ec273f976d49.png";